import type { BundleCartItem as BundleCartItemType } from "../BundleBuilderContext";

import React from "react";

import unescape from "lodash-es/unescape";

import { useBundleBuilder } from "../BundleBuilderContext";
import { BundleQuantitySelector } from "./BundleQuantitySelector";

type BundlePreviewItemProps = {
  item: BundleCartItemType;
  onUpdateQuantity?: (qty: number) => void;
};

export const BundlePreviewItem: React.FC<BundlePreviewItemProps> = ({
  item,
}) => {
  const { getVariantData } = useBundleBuilder();
  const { variant, product } = getVariantData(item.variantId, item.productId);
  const image = variant?.featuredImage ?? product?.featured_image;
  if (!variant) {
    return null;
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        background: "#ffffff",
        borderRadius: "12px",
        paddingRight: "8px",
        border: "1px solid #e2e8f0",
      }}
    >
      {image && (
        <div
          style={{
            width: "69px",
            height: "69px",
            position: "relative",
            overflow: "hidden",
            borderRadius: "8px",
            marginRight: "12px",
          }}
        >
          {image && (
            <img
              src={image}
              alt={variant?.title || product?.title}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}
        </div>
      )}

      <div
        style={{
          flex: 1,
        }}
      >
        <div style={{ fontWeight: "500" }}>{product?.title}</div>
        <div
          style={{ color: "#333", fontSize: "15px" }}
          dangerouslySetInnerHTML={{ __html: unescape(variant.displayPrice) }}
        />
      </div>

      <div style={{ width: "80px" }}>
        <BundleQuantitySelector variantId={item.variantId} />
      </div>
    </div>
  );
};
